<template>
    <div class="header pt-4 pb-7" :style="$bgColor(color.primary)">
        <div class="container">
            <div class="header-body">
                <div class="card px-3 py-4">
                    <div class="row">
                        <h1 class="mb-0 col-9">{{title}}</h1>
                        <div class="col-3" v-if="files.length > 0">
                            <button @click="modalView = true" class="btn-primary btn w-100">{{$t('content.lesson.upload')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="files.length > 0" v-model:show="modalView">
            <div>
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{$t('content.lesson.upload')}}:</h5>
                    <button type="button" class="close" @click="modalView = false" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <hr class="m-0 mb-3">
                <div class="modal-body">
                    <ul>
                        <li v-for="(file,index) in files" :key="index">
                            <span><i class="mdi  pr-1" :class="{'mdi-image' : file.type == 'image', 'mdi-file' : file.type == 'pdf', 'mdi-play' : file.type == 'video'}"></i></span>
                            <a target="_blank" :href="gerateLink(file)" download>{{file.filename}}</a>
                        </li>
                    </ul>
                 </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '../../../argon/components/Modal'

export default {
    name: 'LessonContentHeader',
    props: {
        title: {
            type: String,
            required: true
        },
        files: {
            type: Array,
            default: []
        }
    },
    components: {
        Modal
    },
    data() {
        return {
            modalView: false
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
    },
    methods: {
        gerateLink(file) {
            if (file.urls && file.urls.original) {
                return file.urls.original
            }
            return `/storage/${file.host}/original/${file.original_file}`
        }
    }
}
</script>

<style scoped>

</style>
